export { CONSENT_COOKIE_NAME, CONSENT_POLICY_VERSION } from './policy-version'

/** 180 days, the usual re-consent horizon. */
export const CONSENT_COOKIE_MAX_AGE_SEC = 180 * 24 * 60 * 60

/** Browser tags that may load only after analytics consent. */
export const GTM_ID: string = import.meta.env.VITE_GTM_ID ?? ''
export const AMPLITUDE_API_KEY: string =
  import.meta.env.VITE_AMPLITUDE_API_KEY ?? ''
/** Share of sessions recorded by Amplitude session replay, 0..1. */
export const AMPLITUDE_REPLAY_SAMPLE_RATE = Number(
  import.meta.env.VITE_AMPLITUDE_REPLAY_SAMPLE_RATE ?? 0
)

export const AMPLITUDE_SDK_URL =
  'https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz'
export const AMPLITUDE_REPLAY_URL =
  'https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz'
export const GTM_URL = 'https://www.googletagmanager.com/gtm.js'
